export interface FileValue {
	name: string;
	mime: string;
	base64: string;
}

export const isBase64 = (value: string): boolean =>
	/^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/.test(value);

export function encodeFileValue(name: string, mime: string, base64: string): string {
	return `file:${name};data:${mime || "application/octet-stream"};base64,${base64}`;
}

export function decodeFileValue(value: unknown): FileValue | undefined {
	if(typeof value !== "string") {
		return undefined;
	}

	const match = /^file:([\s\S]+);data:([^,\r\n]*);base64,([A-Za-z0-9+/=]*)$/.exec(value);

	if(!match || !isBase64(match[3])) {
		return undefined;
	}

	return {
		name: match[1],
		mime: match[2],
		base64: match[3]
	};
}

/** Decoded byte count, excluding the filename and data-URL header. */
export function fileSize(value: unknown): number | undefined {
	if(typeof value !== "string") {
		return undefined;
	}

	const body = decodeFileValue(value)?.base64 ?? value;

	if(!isBase64(body)) {
		return undefined;
	}

	const padding = body.endsWith("==") ? 2 : body.endsWith("=") ? 1 : 0;

	return body.length / 4 * 3 - padding;
}
